import PortalIdParser from 'PortalIdParser';
export const getChannelSettingsUrl = ({
  inboxId
}) => `/live-messages-settings/${PortalIdParser.get()}/inboxes/${inboxId}/channels`;